(() => {
  const initializeSenixSpringHero = (root) => {
    if (!root || root.dataset.senixSpringInitialized === 'true') return;
    root.dataset.senixSpringInitialized = 'true';
    const wraps = [...root.querySelectorAll('[data-senix-spring-hotspot-wrap]')];
    const closeAll = (exception) => wraps.forEach((wrap) => {
      if (wrap === exception) return;
      wrap.classList.remove('senix-spring-hero__hotspot-wrap--open');
      wrap.querySelector('[data-senix-spring-hotspot]')?.setAttribute('aria-expanded', 'false');
    });
    wraps.forEach((wrap) => {
      const button = wrap.querySelector('[data-senix-spring-hotspot]');
      if (!button) return;
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        const willOpen = !wrap.classList.contains('senix-spring-hero__hotspot-wrap--open');
        closeAll(wrap);
        wrap.classList.toggle('senix-spring-hero__hotspot-wrap--open', willOpen);
        button.setAttribute('aria-expanded', String(willOpen));
      });
      wrap.addEventListener('mouseenter', () => button.setAttribute('aria-expanded', 'true'));
      wrap.addEventListener('mouseleave', () => {
        if (!wrap.classList.contains('senix-spring-hero__hotspot-wrap--open')) button.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('click', () => closeAll());
    root.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeAll(); });
  };
  document.querySelectorAll('[data-senix-spring-hero]').forEach(initializeSenixSpringHero);
  document.addEventListener('shopify:section:load', (event) => initializeSenixSpringHero(event.target.querySelector('[data-senix-spring-hero]')));
})();
